'use client';

import React, { useState, useEffect, useRef, useCallback } from 'react';
import AppImage from '@/components/ui/AppImage';
import ProductModal from '@/components/ProductModal';

export interface Product {
  name: string;
  composition: string;
  category: string;
  categoryId: string;
  image: string;
  form?: string;
}

const allProducts: Product[] = [
  { name: 'PENTAWIN-DSR', composition: 'Pantoprazole 40 mg + Domperidone 30 mg', category: 'Gastrointestinal Care', categoryId: 'GASTROINTESTINAL', image: '/assets/images/5993de82-5b09-4844-bad8-8e869708a6ca-1789056112530.jpeg' },
  { name: 'EWINCET-O', composition: 'Cefixime 200 mg + Ofloxacin 200 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/34cf7b16-b104-446b-90ee-60f0fa162f7b-1789051227451.jpeg' },
  { name: 'EPOD-50 CV', composition: 'Cefpodoxime 50 mg + Potassium Clavulanate 31.25 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/714de328-69a6-4b49-9843-a0ceb6f36dae-1789051422401.jpeg' },
  { name: 'EPOD-100', composition: 'Cefpodoxime 100 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/72cd4d9d-e37e-41af-a1c6-6db4d19a6c09-1789051422355.jpeg' },
  { name: 'EPOD-200', composition: 'Cefpodoxime Proxetil 200 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/72cd4d9d-e37e-41af-a1c6-6db4d19a6c09-1789051422355.jpeg' },
  { name: 'EWICLAV-625', composition: 'Amoxicillin 500 mg + Potassium Clavulanate 125 mg', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/612f7449-3ed4-4b5f-99dd-3fa958ae9888-1789051192629.jpeg' },
  { name: 'EWICLAV-CV', composition: 'Amoxicillin + Potassium Clavulanate', category: 'Anti-Infective', categoryId: 'ANTI-INFECTIVE', image: '/assets/images/612f7449-3ed4-4b5f-99dd-3fa958ae9888-1789051192629.jpeg', form: 'Pediatric Dry Syrup' },
  { name: 'EWIN-SP', composition: 'Aceclofenac 100 mg + Paracetamol 325 mg + Serratiopeptidase 15 mg', category: 'Pain & Inflammation', categoryId: 'PAIN-INFLAMMATION', image: '/assets/images/2aea4275-b920-42a1-833c-9c210144e5da-1789051422389.jpeg' },
  { name: 'EWINDROT', composition: 'Dicyclomine HCl 20 mg + Paracetamol 500 mg', category: 'Antispasmodic', categoryId: 'ANTISPASMODIC', image: '/assets/images/b239fd02-5f76-4015-82bd-80c9b03bd4e8-1789051422379.jpeg' },
  { name: 'LIVOMONT', composition: 'Levocetirizine 5 mg + Montelukast 10 mg', category: 'Anti-Allergic', categoryId: 'ANTI-ALLERGIC', image: '/assets/images/98660145-df9d-4e9b-a1c5-f211a89eb0de-1789051227432.jpeg' },
  { name: 'EWINCOF-D', composition: 'Dextromethorphan + Phenylephrine + CPM', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/649ddd64-b00a-4fc0-9305-6c7f7ef7a7a1-1789051422349.jpeg' },
  { name: 'EWINCOF-PD', composition: 'Levosalbutamol + Ambroxol + Guaiphenesin', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/c73fca46-0f1b-41fc-b9bb-8f27fdb2c14b-1789051227455.jpeg' },
  { name: 'EWIN-COF', composition: 'Bromhexine + Guaiphenesin + Terbutaline + Menthol', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/4d51e924-672f-4e77-a47d-651759648350-1789056112541.jpeg' },
  { name: 'EWIN-COLD', composition: 'Cetirizine 5 mg + Phenylephrine 5 mg + Paracetamol 325 mg', category: 'Respiratory', categoryId: 'RESPIRATORY', image: '/assets/images/fbab4448-f423-47bb-86a7-62c817649a3d-1789051227458.jpeg' },
  { name: 'ELIV-DS', composition: 'Liver Tonic', category: 'Liver Care', categoryId: 'LIVER-CARE', image: '/assets/images/72c09661-aec8-4e20-8483-27ff9f5e2fc8-1789056112554.jpeg' },
  { name: 'MERCY', composition: 'Lactobacillus rhamnosus + Lactobacillus reuteri', category: 'Probiotic / Women\'s Health', categoryId: 'PROBIOTIC', image: '/assets/images/0c36f435-9f2c-493f-b447-3f3e85a80086-1789056112520.jpeg' },
];

const categories = [
  { id: 'ALL', label: 'All' },
  { id: 'ANTI-INFECTIVE', label: 'Anti-Infective' },
  { id: 'RESPIRATORY', label: 'Respiratory' },
  { id: 'PAIN-INFLAMMATION', label: 'Pain & Inflammation' },
  { id: 'GASTROINTESTINAL', label: 'Gastrointestinal' },
  { id: 'ANTI-ALLERGIC', label: 'Anti-Allergic' },
  { id: 'ANTISPASMODIC', label: 'Antispasmodic' },
  { id: 'LIVER-CARE', label: 'Liver Care' },
  { id: 'PROBIOTIC', label: 'Probiotic / Women\'s Health' },
];

const CARDS_DESKTOP = 3;
const CARDS_TABLET = 2;
const CARDS_MOBILE = 1;

export default function ProductsSection() {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [cardsVisible, setCardsVisible] = useState(CARDS_DESKTOP);
  const sectionRef = useRef<HTMLElement>(null);
  const autoplayRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [isPaused, setIsPaused] = useState(false);

  const filteredProducts = activeCategory === 'ALL'
    ? allProducts
    : allProducts.filter((p) => p.categoryId === activeCategory);

  const totalSlides = Math.max(0, filteredProducts.length - cardsVisible + 1);

  useEffect(() => {
    const getCards = () => {
      if (window.innerWidth < 640) return CARDS_MOBILE;
      if (window.innerWidth < 1024) return CARDS_TABLET;
      return CARDS_DESKTOP;
    };
    setCardsVisible(getCards());
    const handleResize = () => setCardsVisible(getCards());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setCurrentIndex(0);
  }, [activeCategory, cardsVisible]);

  const next = useCallback(() => {
    setCurrentIndex((prev) => (prev >= totalSlides - 1 ? 0 : prev + 1));
  }, [totalSlides]);

  const prev = useCallback(() => {
    setCurrentIndex((prev) => (prev <= 0 ? totalSlides - 1 : prev - 1));
  }, [totalSlides]);

  useEffect(() => {
    if (isPaused || filteredProducts.length <= cardsVisible) return;
    autoplayRef.current = setInterval(next, 4000);
    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };
  }, [isPaused, next, filteredProducts.length, cardsVisible]);

  useEffect(() => {
    const handleFilter = (e: Event) => {
      const customEvent = e as CustomEvent<string>;
      const catMap: Record<string, string> = {
        'ANTI-INFECTIVE': 'ANTI-INFECTIVE',
        'RESPIRATORY': 'RESPIRATORY',
        'GASTROINTESTINAL': 'GASTROINTESTINAL',
        'PAIN-INFLAMMATION': 'PAIN-INFLAMMATION',
        'ANTI-ALLERGIC': 'ANTI-ALLERGIC',
        'ANTISPASMODIC': 'ANTISPASMODIC',
        'LIVER-CARE': 'LIVER-CARE',
        'PROBIOTIC': 'PROBIOTIC',
      };
      const mapped = catMap[customEvent.detail] || 'ALL';
      setActiveCategory(mapped);
    };
    window.addEventListener('filterCategory', handleFilter);
    return () => window.removeEventListener('filterCategory', handleFilter);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.section-reveal').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const cardWidthPercent = 100 / cardsVisible;

  return (
    <>
      <section
        id="products"
        ref={sectionRef}
        className="py-20 lg:py-28 bg-background"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-10 space-y-3">
            <div className="section-reveal stagger-1">
              <span className="section-label">Portfolio</span>
            </div>
            <h2 className="section-reveal stagger-2 font-display text-foreground leading-tight" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}>
              Our Products
            </h2>
            <p className="section-reveal stagger-3 text-muted-foreground max-w-xl mx-auto">
              Quality Healthcare Solutions Across Multiple Therapeutic Segments
            </p>
          </div>

          {/* Category Filters */}
          <div className="section-reveal stagger-2 flex flex-wrap gap-2 justify-center mb-10">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`category-filter-btn ${activeCategory === cat.id ? 'active' : ''}`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Carousel */}
          <div className="section-reveal stagger-3">
            <div
              className="carousel-container"
              onTouchStart={(e) => {
                const touch = e.touches[0];
                (e.currentTarget as HTMLDivElement).dataset.touchStart = touch.clientX.toString();
                setIsPaused(true);
              }}
              onTouchEnd={(e) => {
                const startX = parseFloat((e.currentTarget as HTMLDivElement).dataset.touchStart || '0');
                const endX = e.changedTouches[0].clientX;
                const diff = startX - endX;
                if (Math.abs(diff) > 40) {
                  diff > 0 ? next() : prev();
                }
                setTimeout(() => setIsPaused(false), 3000);
              }}
            >
              <div
                className="carousel-track"
                style={{ transform: `translateX(-${currentIndex * cardWidthPercent}%)` }}
              >
                {filteredProducts.map((product) => (
                  <div
                    key={product.name}
                    className="flex-shrink-0 px-3"
                    style={{ width: `${cardWidthPercent}%` }}
                  >
                    <div className="product-card flex flex-col h-full">
                      {/* Product Image */}
                      <div className="bg-gradient-to-b from-slate-50 to-blue-50 flex items-center justify-center p-6 flex-shrink-0">
                        <AppImage
                          src={product.image}
                          alt={`${product.name} pharmaceutical product creative`}
                          width={300}
                          height={300}
                          className="object-contain w-full h-auto max-h-[260px]"
                          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        />
                      </div>
                      {/* Info */}
                      <div className="p-5 flex flex-col flex-1 gap-2.5">
                        <span className="text-[10px] font-bold tracking-widest uppercase text-secondary">{product.category}</span>
                        <h3 className="font-display text-foreground text-lg leading-tight break-words">{product.name}</h3>
                        {product.form && (
                          <span className="text-xs text-muted-foreground italic">{product.form}</span>
                        )}
                        <p className="text-muted-foreground text-sm leading-relaxed flex-1">{product.composition}</p>
                        <button
                          onClick={() => setSelectedProduct(product)}
                          className="mt-3 pharma-btn-primary w-full justify-center text-sm"
                        >
                          View Product
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Controls */}
            {filteredProducts.length > cardsVisible && (
              <div className="flex items-center justify-center gap-4 mt-8">
                <button onClick={prev} className="carousel-arrow" aria-label="Previous products">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                    <path d="M11 4L6 9L11 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                <div className="flex items-center gap-1.5">
                  {Array.from({ length: totalSlides }).map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setCurrentIndex(i)}
                      className={`dot-indicator ${currentIndex === i ? 'active' : ''}`}
                      aria-label={`Go to slide ${i + 1}`}
                    />
                  ))}
                </div>

                <button onClick={next} className="carousel-arrow" aria-label="Next products">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                    <path d="M7 4L12 9L7 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            )}

            {filteredProducts.length === 0 && (
              <div className="text-center py-16 text-muted-foreground">
                No products found in this category.
              </div>
            )}
          </div>
        </div>
      </section>

      {selectedProduct && (
        <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />
      )}
    </>
  );
}